import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

window.addEventListener('error', (event) => {
  console.log('GLOBAL_ERROR_MSG:', event.error?.message);
  console.log('GLOBAL_ERROR_STACK:', event.error?.stack);
});
window.addEventListener('unhandledrejection', (event) => {
  console.log('UNHANDLED_REJECTION:', event.reason?.message || event.reason);
});

initAnalytics();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
  
  // Listen for navigation messages from service worker (used for notification click handling)
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NAVIGATE_TO_WORKOUT' && event.data?.url) {
      // Navigate to the workout URL
      const url = event.data.url;
      if (url.startsWith('http')) {
        // Absolute URL - extract pathname
        const urlObj = new URL(url);
        window.location.href = urlObj.pathname + urlObj.search;
      } else {
        window.location.href = url;
      }
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
